export default __webpack_public_path__ + "static/media/Handguards of the Furious Swipe.a3e3917b.jpg";